export default "__VITE_ASSET__b333cfb1__"